import script from "./OnboardingFormsView.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingFormsView.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingFormsView.vue?vue&type=style&index=0&id=343a4e57&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-343a4e57"]])

export default __exports__